import * as React from 'react';
import { ScoringSettings } from '../../../../sdk/model';
import { Card, CardHeader, CardContent, Grid, Typography, TextField } from '@mui/material';

interface receivingSettingsProps {
  scoringSettings: ScoringSettings,
  editing: boolean,
  handleChange: Function
}

function ReceivingSettings(props: receivingSettingsProps) {
  function handleChange(event) {
    props.handleChange(event, "receivingScoringSettings")
  }
  return <Card sx={{ border: 1, width: 600 }}>
    <CardHeader sx={{paddingBottom: 0}}
        title={<Typography variant="h4" component="div" color="text.secondary" sx={{ flexGrow: 1 }}>
         Receiving
       </Typography>}>
    </CardHeader>
    <CardContent>
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <TextField name="receptions" label="Receptions" value={props.scoringSettings?.receivingScoringSettings.ALL.receptions} type="number"
              onChange={handleChange} disabled={!props.editing} />
        </Grid>
        <Grid item xs={6}>
          <TextField name="pointsPer" label="Points Per" value={props.scoringSettings?.receivingScoringSettings.ALL.pointsPer} type="number"
              onChange={handleChange} disabled={!props.editing} />
        </Grid>
        <Grid item xs={6}>
          <TextField name="yardsPerPoint" label="Yards" value={props.scoringSettings?.receivingScoringSettings.ALL.yardsPerPoint} type="number"
              onChange={handleChange} disabled={!props.editing} />
        </Grid>
        <Grid item xs={6}>
          <TextField name="tds" label="Touchdowns" value={props.scoringSettings?.receivingScoringSettings.ALL.tds} type="number"
              onChange={handleChange} disabled={!props.editing} />
        </Grid>
        <Grid item xs={6}>
          <TextField name="twoPointConversions" label="2-Point Conversions" value={props.scoringSettings?.receivingScoringSettings.ALL.twoPointConversions} type="number"
              onChange={handleChange} disabled={!props.editing} />
        </Grid>
        <Grid item xs={6}>
          <TextField name="bonusYards" label="Bonus Yards Threshold" value={props.scoringSettings?.receivingScoringSettings.ALL.bonusYards} type="number"
              onChange={handleChange} disabled={!props.editing} />
        </Grid>
        <Grid item xs={6}>
        <TextField name="bonusYardsPoints" label="Bonus Points" value={props.scoringSettings?.receivingScoringSettings.ALL.bonusYardsPoints} type="number"
                      onChange={handleChange} disabled={!props.editing} />
        </Grid>
      </Grid>
    </CardContent>
  </Card>
}

export default ReceivingSettings;
